import { AmplitudeTracker } from '@/services/activityTracker/adapters/amplitude-tracker';
import { ActivityTracker } from '@/services/activityTracker/adapters/contracts/activity-tracker';
import { LocalTracker } from '@/services/activityTracker/adapters/local-tracker';
import { isProd, isStaging } from '@/ui/helpers/systemHelper';
import * as Sentry from '@sentry/browser';
import { MixpanelTracker } from '@/services/activityTracker/adapters/mixpanel-tracker';

export enum Trackers {
  amplitude = 'amplitude',
  mixpanel = 'mixpanel',
}

export class ActivityTrackerFactory {
  make = (service: Trackers): ActivityTracker => {
    switch (service) {
      case Trackers.mixpanel: {
        return new MixpanelTracker(process.env.VUE_APP_MIXPANEL_API_KEY || '');
      }

      case Trackers.amplitude: {
        return new AmplitudeTracker(process.env.VUE_APP_AMPLITUDE_API_KEY || '');
      }

      default: {
        if (isProd || isStaging) {
          Sentry.captureMessage(`No tracking service was set up for environment. Received: ${service}`);
        }
        return new LocalTracker;
      }
    }
  };
}
